import React from 'react';
import { LoadingBadge } from '../loadingBadge';

export interface LoadingChildrenProps {
  children: React.ReactElement;
  loading: boolean;
  loadingClassName: string;
  expectedChars: number;
}

export const LoadingChildren = (props: LoadingChildrenProps) => {
  if (props.loading) {
    return <LoadingBadge expectedChars={props.expectedChars} className={props.loadingClassName} />;
  }
  return props.children;
};
